import React from 'react';
import logoImg from '../../assets/images/logo.png';

// Single source of truth for the Burans Hikes brand logo.
// The logo artwork has dark-green text, so on dark/colored surfaces pass
// `onDark` to wrap it in a white rounded card and keep it readable.
const Logo = ({ height = 40, onDark = false, showText = true, style, imgStyle, alt = 'Burans Hikes — Home Stay (Resort)' }) => {
  const textSize = Math.max(12, Math.min(22, Math.round(height * 0.34)));
  const brand = showText ? (
    <span
      style={{
        display: 'flex',
        flexDirection: 'column',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          color: '#14532d',
          fontSize: textSize,
          fontWeight: 800,
          lineHeight: 1.2,
          textTransform: 'none',
        }}
      >
        Burans Hikes
      </span>
      <span
        style={{
          color: '#14532d',
          fontSize: Math.max(9, Math.round(textSize * 0.7)),
          fontWeight: 600,
          lineHeight: 1.2,
          textTransform: 'none',
        }}
      >
        Homestay(Resort)
      </span>
    </span>
  ) : null;
  const img = (
    <img
      src={logoImg}
      alt={alt}
      style={{ height, width: 'auto', display: 'block', ...imgStyle }}
    />
  );

  const content = (
    <>
      {img}
      {brand}
    </>
  );

  if (!onDark) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: Math.max(8, Math.round(height * 0.22)),
          ...style,
        }}
      >
        {content}
      </span>
    );
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: Math.max(8, Math.round(height * 0.22)),
        backgroundColor: '#ffffff',
        borderRadius: 14,
        padding: '10px 16px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
        ...style,
      }}
    >
      {content}
    </div>
  );
};

export default Logo;
